"use strict";
import { Injector, Inject, InjectionToken } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { CookieOptions } from './cookie-options.model';
import { mergeOptions } from './utils';
export var COOKIE_OPTIONS = new InjectionToken('COOKIE_OPTIONS');
/** @private */
var CookieOptionsProvider = (function () {
    function CookieOptionsProvider(options, _injector) {
        if (options === void 0) { options = {}; }
        this._injector = _injector;
        this.defaultOptions = {
            path: this._injector.get(APP_BASE_HREF, '/'),
        };
        this._options = mergeOptions(this.defaultOptions, options);
    }
    Object.defineProperty(CookieOptionsProvider.prototype, "options", {
        get: function () {
            return this._options;
        },
        enumerable: true,
        configurable: true
    });
    CookieOptionsProvider.ctorParameters = function () { return [{ type: CookieOptions, decorators: [{ type: Inject, args: [COOKIE_OPTIONS] }] }, { type: Injector }]; };
    return CookieOptionsProvider;
}());
export { CookieOptionsProvider };
//# sourceMappingURL=cookie-options-provider.js.map


// WEBPACK FOOTER //
// cookie-options-provider.js